import IAction from "../../types/IAction";
import { readMessageBack } from "../../utils/readMessageBack";
import actionTypes from "../actionTypes";
import ContactCenter from "../../types/ContactCenter";

export interface GetSupervisorContactCenter {
  supervisorContactCenter: ContactCenter[];
  gettingSupervisorContactCenter: boolean;
  gettingSupervisorContactCenterError: string;
}

export interface GetOperadorContactCenter {
  operadorContactCenter: ContactCenter[];
  gettingOperadorContactCenter: boolean;
  gettingOperadorContactCenterError: string;
}

export interface PostContactCenter {
  postingContactCenter: boolean;
  postingContactCenterError: string;
}

interface State
  extends GetSupervisorContactCenter,
    GetOperadorContactCenter,
    PostContactCenter {}

const initialState: State = {
  supervisorContactCenter: null,
  gettingSupervisorContactCenter: false,
  gettingSupervisorContactCenterError: null,
  operadorContactCenter: null,
  gettingOperadorContactCenter: false,
  gettingOperadorContactCenterError: null,
  postingContactCenter: false,
  postingContactCenterError: null
};

export default function contactCenterReducer(
  state: State = initialState,
  action: IAction
): State {
  const snapshot = snapshotAction(state, action);

  state != snapshot &&
    !action.type.endsWith("_PENDING") &&
    action.meta &&
    action.meta.resolver &&
    action.meta.resolver({
      fulfilled: action.type.endsWith("_FULFILLED"),
      ...snapshot
    });

  return state != snapshot
    ? {
        ...state,
        ...snapshot
      }
    : state;
}

function snapshotAction(state: State = initialState, action: IAction) {
  switch (action.type) {
    case `${actionTypes.GET_SUPERVISOR_CONTACT_CENTER}_PENDING`: {
      return {
        gettingSupervisorContactCenter: true,
        gettingSupervisorContactCenterError: null
      };
    }
    case `${actionTypes.GET_SUPERVISOR_CONTACT_CENTER}_REJECTED`: {
      return {
        supervisorContactCenter: null,
        gettingSupervisorContactCenter: false,
        gettingSupervisorContactCenterError: readMessageBack(action)
      };
    }
    case `${actionTypes.GET_SUPERVISOR_CONTACT_CENTER}_FULFILLED`: {
      return {
        supervisorContactCenter: action.payload.data,
        gettingSupervisorContactCenter: false,
        gettingSupervisorContactCenterError: null
      };
    }

    case `${actionTypes.GET_OPERADOR_CONTACT_CENTER}_PENDING`: {
      return {
        gettingOperadorContactCenter: true,
        gettingOperadorContactCenterError: null
      };
    }
    case `${actionTypes.GET_OPERADOR_CONTACT_CENTER}_REJECTED`: {
      return {
        operadorContactCenter: null,
        gettingOperadorContactCenter: false,
        gettingOperadorContactCenterError: readMessageBack(action)
      };
    }
    case `${actionTypes.GET_OPERADOR_CONTACT_CENTER}_FULFILLED`: {
      return {
        operadorContactCenter: action.payload.data,
        gettingOperadorContactCenter: false,
        gettingOperadorContactCenterError: null
      };
    }

    case `${actionTypes.POST_CONTACT_CENTER}_PENDING`: {
      return {
        postingContactCenter: true,
        postingContactCenterError: null
      };
    }
    case `${actionTypes.POST_CONTACT_CENTER}_REJECTED`: {
      return {
        postingContactCenter: false,
        postingContactCenterError: readMessageBack(action)
      };
    }
    case `${actionTypes.POST_CONTACT_CENTER}_FULFILLED`: {
      return {
        postingContactCenter: false,
        postingContactCenterError: null
      };
    }

    default:
      return state;
  }
}
